import { useEffect, useMemo } from 'react';
import { DueDiligenceStatus } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { getFiDispensaryStore } from 'stores/FiDispensaryStore';
import { MUOS_KEY } from './consts';
import { useUser } from './useUser';

export function useMuos() {
  const bankApi = new BanksApi();
  const bankDispensaryStore = getFiDispensaryStore();
  const { userBankId } = useUser();

  const { data: allMuos, isLoading: isLoadingMuos } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [MUOS_KEY, userBankId],
    queryFn: () => bankApi.getMuo(userBankId)
  });

  const { activeMuos, archivedMuos } = useMemo(() => {
    if (!allMuos) return { activeMuos: undefined, archivedMuos: undefined };

    const activeMuos = allMuos.filter(
      ({ assigned_onboarding_template }) =>
        assigned_onboarding_template.status !== DueDiligenceStatus.BANK_DISCONNECTED
    );
    const archivedMuos = allMuos.filter(
      ({ assigned_onboarding_template }) =>
        assigned_onboarding_template.status === DueDiligenceStatus.BANK_DISCONNECTED
    );

    return { activeMuos, archivedMuos };
  }, [allMuos]);

  useEffect(() => {
    if (activeMuos?.length) {
      bankDispensaryStore.setBankMuos(activeMuos);
    }
    if (archivedMuos?.length) {
      bankDispensaryStore.setBankMuosArchived(archivedMuos);
    }
  }, [activeMuos, archivedMuos]);

  return { allMuos, activeMuos, archivedMuos, isLoadingMuos };
}
